export default {
  placeLabel: 'Stn',
  ruralRouteLabel: 'RR',
  poBoxLabel: 'PO Box',
};
